<div class="receivables-payment-import-row-details-view-container" *ngIf="receivablesPaymentImportsRowObject" fxLayout="column" fxLayoutGap="15px" >
  <div class="status-info">
    <mat-form-field appearance="fill" [ngClass]="'input-color-' + receivablesPaymentImportsRowObject.status?.color">
      <mat-label>Status</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="receivablesPaymentImportsRowObject.status?.name">
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <button
      [disabled]="!(userPermissions | async).receivables.write"
      *ngIf="[RECEIVABLES_PAYMENT_STATUS_UNSETTLED, RECEIVABLES_PAYMENT_STATUS_OUTGOING_PAYMENT].includes(receivablesPaymentImportsRowObject?.status.key)"
      mat-stroked-button
      (click)="addBalance()"
    ><mat-icon>add</mat-icon><span> Dodaj Saldo</span></button>
    <button
      [disabled]="!(userPermissions | async).receivables.write"
      mat-stroked-button (click)="modify()"
    ><mat-icon>edit</mat-icon><span> Edytuj</span></button>
    <button
      [disabled]="!(userPermissions | async).receivables.delete"
      *ngIf="[RECEIVABLES_PAYMENT_STATUS_UNSETTLED, RECEIVABLES_PAYMENT_STATUS_SETTLED, RECEIVABLES_PAYMENT_STATUS_OUTGOING_PAYMENT].includes(receivablesPaymentImportsRowObject?.status.key) && !receivablesPaymentImportsRowObject?.transfer"
      mat-stroked-button (click)="cancel()" color="warn"
    ><mat-icon>cancel</mat-icon><span> Usuń</span></button>

    <button
      [disabled]="!(userPermissions | async).receivables.admin_root"
      *ngIf="[RECEIVABLES_PAYMENT_STATUS_UNSETTLED, RECEIVABLES_PAYMENT_STATUS_SETTLED, RECEIVABLES_PAYMENT_STATUS_OUTGOING_PAYMENT].includes(receivablesPaymentImportsRowObject?.status.key) && receivablesPaymentImportsRowObject?.transfer"
      mat-stroked-button (click)="cancel()" color="warn"
    ><mat-icon>cancel</mat-icon><span> Usuń</span></button>


  </div>

  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px" style=" top: 55px;">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Dane wpłaty</h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Tytuł przelewu" [value]="receivablesPaymentImportsRowObject?.transferTitle"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Podmiot transakcji" [value]="receivablesPaymentImportsRowObject?.ownerName"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Kwota przelewu" >
                  {{(receivablesPaymentImportsRowObject.transferAmount === null ? 0 : receivablesPaymentImportsRowObject.transferAmount) | number:'1.2-2'}} zł
                </app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Uwagi</h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="" [value]="receivablesPaymentImportsRowObject?.note"></app-detail>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </div>


    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Saldo</h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Numer salda" >
                  <a *ngIf="receivablesPaymentImportsRowObject?.receivablesBalance?.recordId"  class="default-link" [routerLink]="['/naleznosci/salda/szczegoly', receivablesPaymentImportsRowObject?.receivablesBalance?.uuid]">
                    {{ receivablesPaymentImportsRowObject?.receivablesBalance?.recordId }}
                  </a>
                </app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Partner/OFWCA" >
                  <a *ngIf="receivablesPaymentImportsRowObject?.receivablesBalance?.partner"  class="default-link" [routerLink]="['/partnerzy/szczegoly', receivablesPaymentImportsRowObject?.receivablesBalance?.partner?.uuid]">
                    {{receivablesPaymentImportsRowObject?.receivablesBalance?.partner?.shortName}}
                  </a>
                  <a *ngIf="receivablesPaymentImportsRowObject?.receivablesBalance?.ofwca"  class="default-link" [routerLink]="['/ofwca/szczegoly', receivablesPaymentImportsRowObject?.receivablesBalance?.ofwca?.uuid]">
                    {{receivablesPaymentImportsRowObject?.receivablesBalance?.ofwca?.fullName}}
                  </a>
                </app-detail>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
</div>
